import { Flex, Image, Heading } from '@chakra-ui/react';
import playStore from '../../../assets/google-play.svg';
import { useMediaQuery } from '@chakra-ui/react';
import SKButton from '../SKButton';
import { DOWNLOAD_PAGE } from 'constants/route.const';
import { useNavigate } from 'react-router-dom';
export default function CTA() {
  let navigate = useNavigate();
  const [isMediumW] = useMediaQuery('(min-width:420px) and (max-width:490px)');
  return (
    <Flex
      alignItems={'flex-start'}
      mt={['20px', null, '0px']}
      flexWrap={'wrap'}
      gap={4}
      flexDirection="column"
    >
      <Heading
        maxW="300px"
        fontSize={['1rem', null, '1rem']}
        color="#000000"
        fontWeight={'semibold'}
        mr={['0px', '20px']}
        textAlign={['left']}
      >
        Download our Mobile app
      </Heading>

      <SKButton
        color="black"
        p="1.75rem 2rem"
        bgGradient="linear(to-r, #FFC968, #FBE6AE)"
        fontWeight="500"
        onClick={() => {
          window.gtag &&
            window.gtag('event', 'chillarpro_download', {
              from: 'HOMEPAGE_CTA',
            });
          navigate(DOWNLOAD_PAGE);
        }}
      >
        Download Chillar Pro Now
      </SKButton>
    </Flex>
  );
}
